import React from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { get, map, upperCase } from 'lodash';
import axios from 'axios';
import classnames from 'classnames';
import { toast } from 'react-toastify';
import withRouter from 'react-router-dom/withRouter';
import ModalItensElaborador from './ModalItensElaborador';
import FiltroAvancadoItens from './FiltroAvancadoItens';
import ElaboradoresTab from './ElaboradoresTab';
import PedidosTab from './PedidosTab';
import { API_HOST } from '../../consts';
import RevisoresTab from './RevisoresTab';

class ListaEncomendaCardTabs extends React.Component {
  static defaultProps = {
    pedidos: []
  };

  state = {
    activeTab: 'pedidos',
    itensVinculados: [],
    ordering: null
  };

  get initialValuesBuscaAvancadaItem() {
    const { pedidoSelecionado } = this.state;

    if (!pedidoSelecionado) {
      return {};
    }

    return {
      matriz_referencia: get(pedidoSelecionado, 'matriz_referencia.id'),
      competencia: get(pedidoSelecionado, 'competencia.id'),
      habilidade: get(pedidoSelecionado, 'habilidade.id')
    };
  }

  get filtroModalItensElaborador() {
    const { selecionado } = this.state;
    return {
      criado_por: get(selecionado, 'usuario_id'),
      pedido: get(selecionado, 'pedido_id')
    };
  }

  get filtroModalItensRevisor() {
    const { selecionado } = this.state;
    return {
      revisado_por: get(selecionado, 'usuario_id'),
      encomenda_id: get(selecionado, 'encomenda_id')
    };
  }

  toggle(tab) {
    this.setState({ activeTab: tab });
  }

  toggleModal(name, extra = {}) {
    const { openModal } = this.state;
    this.setState({ openModal: openModal === name ? null : name, ...extra });
  }

  handleVincularError(error) {
    const status = get(error, 'response.status');
    if (status === 400) {
      const errors = [
        ...get(error, 'response.data.item', []),
        ...get(error, 'response.data.non_field_errors', [])
      ];
      toast.error(
        <ul>
          {errors.map((e) => (
            <li key={e}>{e}</li>
          ))}
        </ul>
      );
    } else {
      toast.error('Ocorreu um erro.');
    }
  }

  vincularItem = (item) => {
    const { pedidoSelecionado } = this.state;
    axios
      .post(`${API_HOST}/encomenda/elaborador_item`, {
        item: item.id,
        pedido: pedidoSelecionado.id
      })
      .then(() => {
        toast.success('Item vinculado com sucesso.');
        const { itensVinculados } = this.state;
        this.setState({ itensVinculados: [...itensVinculados, item.id] });
      })
      .catch((e) => {
        this.handleVincularError(e);
      });
  };

  desvincularItem = (item) => {
    const { pedidoSelecionado } = this.state;
    axios
      .delete(
        `${API_HOST}/encomenda/pedido/${pedidoSelecionado.id}/desvincular`,
        {
          params: {
            item: item.id
          }
        }
      )
      .then(() => {
        toast.success('Item desvinculado com sucesso.');
        const { itensVinculados } = this.state;
        this.setState({
          itensVinculados: itensVinculados.filter((d) => d !== item.id)
        });
      })
      .catch((e) => {
        this.handleVincularError(e);
      });
  };

  handleVincularItens = (pedido) => {
    this.setState({
      pedidoSelecionado: pedido,
      openModal: 'vincularItens'
    });
  };

  filterTable = (list, search) => {
    const { ordering } = this.state;
    if (ordering) {
      const { index, desc } = ordering;
      list.sort((a, b) => {
        if (a[index] > b[index]) {
          return desc ? -1 : 1;
        }
        if (a[index] < b[index]) {
          return desc ? 1 : -1;
        }
        return 0;
      });
    }
    if (search) {
      return list.filter((e) => upperCase(e).includes(upperCase(search)));
    }

    return list;
  };

  handleVerMaisPedido = (row) => {
    const itensElaboradorProps = {
      nome: row.original.nome,
      id: row.original.id,
      filters: {
        elaborador: row.original.id
      }
    };
    this.toggleModal('itensElaborador', { itensElaboradorProps });
  };

  render() {
    const { activeTab, itensVinculados, openModal, itensElaboradorProps } =
      this.state;
    const { tabs, encomenda, pedidos, view_revisor_permission } = this.props;

    return (
      <div className="card-item card-alone">
        <Nav tabs>
          {tabs.find((d) => d === 'pedidos') && (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'pedidos' })}
                onClick={() => this.toggle('pedidos')}
              >
                Pedidos
              </NavLink>
            </NavItem>
          )}
          {tabs.find((d) => d === 'elaboradores') && (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'elaboradores' })}
                onClick={() => this.toggle('elaboradores')}
              >
                Elaboradores
              </NavLink>
            </NavItem>
          )}
          {tabs.find((d) => d === 'revisores') && (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'revisores' })}
                onClick={() => this.toggle('revisores')}
              >
                Revisores
              </NavLink>
            </NavItem>
          )}
        </Nav>

        <TabContent activeTab={activeTab}>
          {tabs.find((d) => d === 'pedidos') && (
            <TabPane tabId="pedidos">
              <div className="card-body no-radius-top">
                {map(pedidos, (pedido) => (
                  <PedidosTab
                    key={pedido.id}
                    startCollapsed={view_revisor_permission}
                    pedido={pedido}
                    handleVincularItens={() => this.handleVincularItens(pedido)}
                    handleVerMais={(row) =>
                      this.handleVerMaisPedido(row, pedido.id)
                    }
                    getItensVinculados={(itens) =>
                      this.setState({ itensVinculados: itens })
                    }
                  />
                ))}
              </div>
            </TabPane>
          )}
          {tabs.find((d) => d === 'revisores') && (
            <TabPane tabId="revisores">
              <div className="card-body no-radius-top">
                <RevisoresTab
                  history={this.props.history}
                  encomenda={encomenda}
                  shouldFetchData={activeTab === 'revisores'}
                />
              </div>
            </TabPane>
          )}
          {tabs.find((d) => d === 'elaboradores') && (
            <TabPane tabId="elaboradores">
              <div className="card-body no-radius-top">
                <ElaboradoresTab
                  encomenda={encomenda}
                  shouldFetchData={activeTab === 'elaboradores'}
                />
              </div>
            </TabPane>
          )}
        </TabContent>

        <FiltroAvancadoItens
          isOpen={openModal === 'vincularItens'}
          toggle={() => this.toggleModal('vincularItens')}
          filter={false}
          onResultClick={this.vincularItem}
          checked={itensVinculados}
          initialValues={this.initialValuesBuscaAvancadaItem}
          vincularItem={this.vincularItem}
          desvincularItem={this.desvincularItem}
        />

        <ModalItensElaborador
          isOpen={openModal === 'itensElaborador'}
          toggle={() =>
            this.toggleModal('itensElaborador', { selecionado: null })
          }
          {...itensElaboradorProps}
        />
      </div>
    );
  }
}

export default withRouter(ListaEncomendaCardTabs);
